<script>
  import { onMount } from "svelte";
  import moment from "moment";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../server";
  import SelectPlayers from "../player/SelectPlayers.svelte";
  import SelectGames from "../player/SelectGames.svelte";

  export let isNew = false;
  export let campaign;
  export let listCampaign;

  let isLoading = false;
  let status_response = false;
  let message = "";
  let showAlert = false;
  let loadingStakes = false;
  let configBonnus = { games: [], players: [], client: { id: null } };
  let stakes = [];

  let isSelectPlayer = false;
  const selectPlayers = () => {
    isSelectPlayer = true;
  };
  let isSelectGames = false;
  const selectGames = () => {
    isSelectGames = true;
  };

  const playesExtraction=(updatedConfig)=> {
    configBonnus = updatedConfig;
    isSelectPlayer = false;
    console.log("Player Recivied: ", configBonnus);
  }
  const gamesExtraction=(updatedConfig)=> {
    configBonnus = updatedConfig;
    isSelectGames = false;
    console.log("Games Recivied: ", configBonnus);
  }

  onMount(async () => {
    campaign.offerId = generateOfferId();
  });

  const generateOfferId = () => {
    const randomNumber = Math.floor(1000000 + Math.random() * 9000000);
    const timestamp = moment().format("YYYYMMDDHHmmss");
    return `${randomNumber}${timestamp.slice(-5)}`;
  };

  const handlePlayerChange = (event) => {
    stakes=[];
    const id = event.target.value;
    const player = configBonnus.players.find((p) => p.id == id);
    if (player) {
      campaign.settings.currency = player.currency,
      campaign.username = `${player.firstname} - ${player.username_origin}`;
    }
    else {
      campaign.settings.currency = null;
      campaign.username = null
    }
  };

  const selectGame=(game)=> {
    stakes=[];
    campaign.game = game.gameid;
  }

 
  const closeModal = () => {
    showAlert = false;
    isNew = false;
  };
 
  const saveFreeSpin = async () => {
    isLoading = true;
    showAlert = false;
    campaign.expiredAt = convertToServerFormat(expiredAtInput);
    campaign.game = campaign.game.replace(/^\d+-/, "");
  
    if (!campaign.settings.bet || campaign.settings.bet <= 0) {
 
  return;
}

if (!campaign.settings.count || campaign.settings.count < 1) {
 
  return;
}

    try {
      let response = await backend.freespin.saveBarbaraBang(campaign);
      if (response.status) {
        message = response.data.success;
        status_response = response.data.success;
        if (status_response) {
          message = ["La campaña fue guardada exitosamente."];
          message = response.data.success;
          listCampaign();
          closeModal();
        } else {
          message =
            response.data?.error?.message || response.data.message || "";
        }
      } else {
      }
    } catch (error) {
      status_response = false;
    } finally {
      isLoading = false;
      showAlert = true;
    }
  };

  const convertToInputFormat=(dateString)=> {
    if (!dateString) return "";
    return moment(dateString, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm");
  }

  const convertToServerFormat=(inputValue)=> {
    if (!inputValue) return "";
    return moment(inputValue, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm:ss");
  }

  let expiredAtInput = convertToInputFormat(campaign.expiredAt);


  const requestStakes= async()=> {
  loadingStakes = true;
  const cleanGame = campaign.game.replace(/^\d+-/, "");
  const params = {
    accountId: campaign.accountId,
    game: cleanGame,
    currency: campaign.settings.currency,
    signature: "***",
  };

  try {
    const response = await backend.freespin.stakesBarBaraBang(params);
    console.log("respuesta:", response.data ?? []);
    stakes = response?.data ?? [];
    if(stakes.length !=0){
      status_response=false;
      message = response.data?.error || response.data.message || ""; 
    }
  } catch (err) {
    console.log("🚨 Error al solicitar stakes:", err);
  } finally {
    loadingStakes = false;
  }
}

</script>

<Modal isOpen={isNew} toggle={closeModal} size="xl">
  <ModalHeader toggle={closeModal}>CREAR RONDAS GRATUITAS BB.</ModalHeader>
  <ModalBody>
    <div class="freeSpin-modal">
      {#if showAlert}
        <div
          class={`alert alert-${status_response ? "success" : "danger"} alert-dismissible fade show`}
          role="alert"
        >
          <strong>{status_response ? "¡Éxito!" : "¡Error!"}</strong>
          {#if Array.isArray(message)}
            {#each message as msg}
              <li>{msg}</li>
            {/each}
          {:else}
            <li>{message}</li>
          {/if}
          <button
            type="button"
            class="btn-close"
            on:click={() => (showAlert = false)}
          ></button>
        </div>
      {/if}

      <div class="list-inputs">
        <label>
          ID de cuenta
          <input class="form-control" bind:value={campaign.accountId} disabled />
        </label>
        <label>
          Juegos:
          <!-- games, -->
          <div class="card entities-list">
            <div  class="card-header d-flex justify-content-between align-items-center"  >
              <p class="mb-0">Juegos agregados</p>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-secondary rounded-pill">
                  {configBonnus.games.length}
                </span>
                <button
                  on:click={() => selectGames()}
                  class="btn btn-outline-secondary btn-sm"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Nuevos
                </button>
              </div>
            </div>

            <div class="card-body" style="max-height: 150px; overflow-y: auto;">
              {#if configBonnus.games.length > 0}
                <div class="list-group">
                  {#each configBonnus.games ?? [] as game}
                    <label class="list-group-item d-flex align-items-center">
                      <input
                        type="radio"
                        name="selectedGame"
                        class="form-check-input me-2"
                        value={game.gameid}
                        checked={campaign.gameid === game.gameid}
                        on:change={() => selectGame(game)}
                      />
                      <span>{game.name}</span>
                    </label>
                  {/each}
                </div>
              {:else}
                <p class="text-center text-muted mb-0">
                  No hay juegos seleccionados.
                </p>
              {/if}
            </div>
          </div>
        </label>

        <label>
          Jugador:
          <div class="input-group mb-3">
            <select
              bind:value={campaign.userId}
              class="form-control"
              required
              on:change={handlePlayerChange}
            >
              <option value="" disabled selected>Selecciona un jugador</option>
              {#each configBonnus.players ?? [] as player}
                <option value={player.id}
                  >{player.firstname}
                  {player.lastname} - ({player.username_origin}-{player.id})</option
                >
              {/each}
            </select>
            <button
              on:click={() => selectPlayers()}  class="btn btn-outline-secondary btn-sm" >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Nuevos
            </button>
          </div>

        </label>

        </div>
        <div class="list-inputs">
        <label>
          ID de la oferta:
          <input class="form-control" bind:value={campaign.offerId} disabled />
        </label>

        <label>
          Fecha de vencimiento
          <input
            type="datetime-local"
            class="form-control"
            bind:value={expiredAtInput}
          />
        </label>
        <label>
            Moneda:
          <input
            class="form-control"
            bind:value={campaign.settings.currency}
            disabled
          />
        </label>

        </div>

        <div class="list-inputs">
    
          <label>
            Cantidad fija que debe apostarse en cada tiro
            <div class="input-group mb-3">
               {#if campaign.userId && campaign.game}
               <select class="form-select"  bind:value={campaign.settings.bet}>
                 <option value="" disabled selected>Selecciona la apuesta</option>
                 {#each stakes as option}
                   <option value={option}>{option}</option>
                 {/each}
               </select>
               <button
               on:click={requestStakes}
               class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
               type="button" disabled={loadingStakes} >
               {#if loadingStakes}
                 <span  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"  ></span>
                 Cargando...
               {:else}  <i class="fa fa-sync-alt"></i>  Sincronizar
               {/if}
             </button>
             {:else}  <p>No hay montos disponibles</p>
             {/if}
            </div>
          </label>

          <label>
            Número total de giros gratis:
            <input
              type="number" class="form-control"  bind:value={campaign.settings.count}  />
          </label>
      
      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    <button  class="btn btn-primary" on:click={saveFreeSpin}   disabled={isLoading}  >
      {#if isLoading}
        <span class="spinner-border spinner-border-sm"  role="status"  aria-hidden="true"></span>
        Cargando...
      {:else}
        Guardar
      {/if}
    </button>
  </ModalFooter>
</Modal>

{#if isSelectPlayer}
  <SelectPlayers {configBonnus} onSave={playesExtraction} bind:isSelectPlayer />
{/if}
{#if isSelectGames}
  <SelectGames {configBonnus} onSave={gamesExtraction} bind:isSelectGames />
{/if}

<style>
  .freeSpin-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .list-inputs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
</style>
